import(/* webpackMode: "eager" */ "/workspace/purpose-it/purpose-fe-monorepo/apps/benefits-widget/app/page.tsx");
